"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Months = exports.DateTimeStyle = void 0;
exports.formatDateTime = formatDateTime;
var constants_1 = require("./constants");
var utils_1 = require("./utils");
exports.DateTimeStyle = {
    DATE_ONLY: 'date_only',
    DATE_TIME: 'date_time',
    MONTH_ONLY: 'month_only'
};
exports.Months = 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(',');
var TIMEZONE_MAPPINGS = {
    KST: ['korea', 'seoul'],
    'CST (UTC+8)': ['china', 'shanghai', 'beijing'],
    JST: ['japan', 'tokyo'],
    PST: ['los_angeles', 'america/los_angeles', 'pacific'],
    EST: ['new_york', 'america/new_york', 'eastern']
};
function padZero(value) {
    return String(value).padStart(2, '0');
}
function getDateParts(date, timeZone) {
    var options = __assign({ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }, (timeZone ? { timeZone: timeZone } : {}));
    var parts = new Intl.DateTimeFormat('en-US', options).formatToParts(date);
    var get = function (type) { var _a; return parseInt(((_a = parts.find(function (p) { return p.type === type; })) === null || _a === void 0 ? void 0 : _a.value) || '0'); };
    return {
        month: get('month') - 1,
        day: get('day'),
        year: get('year'),
        hours: get('hour'),
        minutes: get('minute'),
        seconds: get('second')
    };
}
function formatTime(date, timeZone) {
    var _a = getDateParts(date, timeZone), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
    return "".concat(padZero(hours), ":").concat(padZero(minutes), ":").concat(padZero(seconds));
}
function getTimeZoneSuffix(timeZone) {
    var e_1, _a;
    if (!timeZone) {
        return '';
    }
    var tz = timeZone.toLowerCase();
    try {
        for (var _b = __values(Object.entries(TIMEZONE_MAPPINGS)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), suffix = _d[0], keywords = _d[1];
            if (keywords.some(function (keyword) { return tz.includes(keyword); })) {
                return suffix;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var offset = new Date().toLocaleString('en-US', {
        timeZone: timeZone,
        timeZoneName: 'shortOffset'
    });
    var match = offset.match(/GMT([+-]\d+)/);
    if (match) {
        return "GMT".concat(match[1]);
    }
    return 'GMT+0';
}
function formatDateTime(_a) {
    var locale = _a.locale, date = _a.date, style = _a.style, timeZone = _a.timeZone;
    var _b = getDateParts(date, timeZone), month = _b.month, day = _b.day, year = _b.year;
    var tzSuffix = getTimeZoneSuffix(timeZone);
    var pLocale = locale ? locale : (0, utils_1.getCurrentLanguage)();
    switch (pLocale) {
        case constants_1.SUPPORTED_LANGUGES.KO_KR:
            switch (style) {
                case exports.DateTimeStyle.DATE_ONLY:
                    return "".concat(year, "/").concat(padZero(month + 1), "/").concat(padZero(day));
                case exports.DateTimeStyle.MONTH_ONLY:
                    return padZero(month + 1);
                case exports.DateTimeStyle.DATE_TIME:
                default:
                    return "".concat(year, "/").concat(padZero(month + 1), "/").concat(padZero(day), " ").concat(formatTime(date, timeZone), " ").concat(tzSuffix).trim();
            }
        case constants_1.SUPPORTED_LANGUGES.EN_US:
        default:
            switch (style) {
                case exports.DateTimeStyle.DATE_ONLY:
                    return "".concat(exports.Months[month], " ").concat(day, ", ").concat(year);
                case exports.DateTimeStyle.MONTH_ONLY:
                    return exports.Months[month];
                case exports.DateTimeStyle.DATE_TIME:
                default:
                    return "".concat(exports.Months[month], " ").concat(day, ", ").concat(year, " ").concat(formatTime(date, timeZone), " ").concat(tzSuffix).trim();
            }
    }
}
